'use client'
import * as React from 'react'
import videojs from 'video.js'

import { EMPTY_ARROW_FUNC } from '@src/config/constants'
import { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import Player from 'video.js/dist/types/player'
import { VideoJS } from './video-js'

export const getVideoPlayerDevice = () => {
  if (isBrowser()) {
    const isMobileQuery = window.matchMedia(`(max-width:  960px)`)
    if (isMobileQuery.matches) {
      return DEVICE_TYPES.MOBILE
    } else {
      return DEVICE_TYPES.DESKTOP
    }
  }
}

// Styles
export interface TVideoLink {
  DESKTOP: string
  MOBILE: string
}

interface IVideoPlayerProps {
  videoLink: TVideoLink
  transformScale: string
  poster?: string
  height?: number
  width?: number
  options?: any
  className?: string
  style?: React.CSSProperties
  onPlayingCB?: () => void
  onCleanUpCB?: () => void
  onErrorCB?: (message?: string) => void
}

const VideoPlayer: React.FC<IVideoPlayerProps> = ({
  className,
  style,
  onPlayingCB,
  videoLink,
  poster,
  transformScale,
  onCleanUpCB,
  onErrorCB = EMPTY_ARROW_FUNC,
}) => {
  const playerRef = React.useRef(null)
  const videoPlayerDevice = getVideoPlayerDevice()
  if (!videoPlayerDevice) return <></>

  const handlePlayerReady = (player: Player) => {
    if (!player) return
    playerRef.current = player
    player.autoplay(true)
    void player.play()
    // You can handle player events here, for example:
  }

  const videoSrc = videoLink[videoPlayerDevice]

  const videoJsOptions: videojs.PlayerOptions = {
    autoplay: true,
    controls: false,
    responsive: false,
    muted: true,
    techOrder: ['html5'],
    fill: true,
    loop: true,
    poster: poster,
    retryOnError: true,
    playsinline: true,
    sources: [
      {
        src: videoSrc,
        type: 'application/x-mpegURL',
      },
    ],
  }

  return (
    <div className={className} style={style}>
      <VideoJS
        transformScale={transformScale}
        onPlayingCB={onPlayingCB}
        options={videoJsOptions}
        onReady={handlePlayerReady}
        onCleanUpCB={onCleanUpCB}
        onErrorCB={onErrorCB}
      />
    </div>
  )
}

export { VideoPlayer }
